
import commands from './commands';
import docker from './docker';
import layer from './layer';
import logger from './logger';
import pkg from './pkg';
import templating from './templating';

export default {
  commands,
  docker,
  layer,
  logger,
  pkg,
  templating,
};
